import { render } from "./RedaccionToolComponent.vue?vue&type=template&id=5937e3bd&scoped=true"
import script from "./RedaccionToolComponent.vue?vue&type=script&lang=js"
export * from "./RedaccionToolComponent.vue?vue&type=script&lang=js"

import "./RedaccionToolComponent.vue?vue&type=style&index=0&id=5937e3bd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5937e3bd"]])

export default __exports__